import { gql } from "@apollo/client";

export const USER_CREATE_BUYER = gql`
	mutation Mutation($params: UserInputParam) {
		user(params: $params) {
			update {
				name
				id
				relation
				groups {
					relationship
					members {
						name
						id
						designation
					}
					type
					name
					id
				}
				emails {
					address
					id
					type
					verified
				}
				phones {
					id
					number
					type
					verified
				}
				profile {
					addresses {
						type
						value
					}
					idProofs {
						id
						type
					}
					utcOffset {
						offset
						utc
						value
					}
					name
					image
				}
			}
		}
	}
`;

export const USER_RELATION_MUTATION = gql`
	mutation UpdateUserRelation($params: UserInputParam) {
		user(params: $params) {
			update {
				name
				id
				relation
				groups {
					relationship
					members {
						name
						id
						designation
					}
					type
					name
					id
				}
				emails {
					address
					id
					type
					verified
				}
				phones {
					id
					number
					type
					verified
				}
				profile {
					addresses {
						type
						value
					}
					idProofs {
						id
						type
					}
					utcOffset {
						offset
						utc
						value
					}
					name
					image
				}
			}
		}
	}
`;
